<app-header-user></app-header-user>
<section class="account-page mrgn-top greybg py-5">
<div class="container">
  <div class="">

   

  <div class="row mt-2 mt-md-0"> 

      <aside class="col-sm-6 col-md-4 col-lg-3">
        <app-userdashboard-sidebar>  </app-userdashboard-sidebar>  
      </aside>
      <div class="col-sm-6 col-md-8 col-lg-9 mt-3 mt-md-0 rside-text">
        <app-userheading-section></app-userheading-section>
        <div *ngIf="isLoading">
        
          <div class="my-accountload text-center">
            <span class="lodercont">
              <app-refreshloader> </app-refreshloader> 
            </span>
          </div>
        </div>
        <div class="row">

          <div class="col-md-10 mb-4 offset-md-1" *ngFor="let ord of orddata">
            <div class="profile-content orders-list">
            
            <div class="media my-order-box">
              
              <div class="media-body">
                <div class="row align-items-center">
                <div class="col-md-3 pr-md-0">
                  <img class="card-img-top" class="img-fluid" src="{{imgurl}}{{ord.pImage}}" >
                </div>
                  <div class="col-md-5">
                <h5 class="ordnumber"><a [routerLink]="['/my-account/order-details', ord['orderid'] ]">{{ 'myaccount.order' | translate }}#{{ord['orderid']}}</a></h5> 
                <p class="orddate"> {{ 'myaccount.date' | translate }}: {{ord['created_at'] | date : 'dd-MM-yyyy'}} </p>  
                </div>
                  <div class="col-md-4 text-right">
                    <h5 class="ordamnt"> 
                      AED {{ord['finalTotal']}}
                    </h5>
                    <p class="ordstatus">{{ord['order_status']}}</p>
                </div>
                </div>
            </div>
          </div>
          </div>
        </div>

      </div>
    </div>

              </div>
          </div>
      </div>
  </section>
